import { ActionButton, Content, Dialog, DialogTrigger, Flex, Heading, ProgressCircle } from '@adobe/react-spectrum';
import Provider from '@react/react-spectrum/Provider';
import Filter from '@spectrum-icons/workflow/Filter';
import React from 'react';

import { useStore } from '../../store';
// Local libs
import SideBar from '../search-sidebar/SideBar';

export const FiltersDialogTrigger = () => {
  const loading = useStore((state) => state.loading);
  return (
    <DialogTrigger isDismissable>
      <ActionButton isQuiet marginStart="10px" data-testid="browse-trigger">
        <Filter size="S" />
      </ActionButton>
      <Dialog size="M">
        <Heading>
          <Flex>
            Filters
            {loading && (
              <ProgressCircle marginStart="8px" marginTop="4px" isIndeterminate size="S" aria-label="Updating search" />
            )}
          </Flex>
        </Heading>
        <Content>
          <Provider toastPlacement="bottom center" theme="light">
            <SideBar />
          </Provider>
        </Content>
      </Dialog>
    </DialogTrigger>
  );
};
